module.exports = __webpack_public_path__ + "static/HelgenishGirolleA-a84d46b4452c94c9e80d5617420cff33.gif";